module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-bc25c8b965efdad14cad10aa1ccc4de2.png";